import { type DatasetFreshnessStatus } from '../types';

const OLD_DATA_THRESHOLD_DAYS = 2;

/**
 * Returns the freshness status of a dataset based on how many calendar days
 * have passed since it was last updated.
 */
export const getDatasetFreshnessStatus = (
  ageDays: number,
): DatasetFreshnessStatus => {
  return ageDays >= OLD_DATA_THRESHOLD_DAYS ? 'old' : 'new';
};
